// src/super/SuperTools.jsx
import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useAuth } from '../auth/AuthProvider';

const REGION = 'us-central1';

export default function SuperTools() {
  const { claims } = useAuth();
  const [orgId, setOrgId] = useState('');
  const [busy, setBusy] = useState(false);
  const [out, setOut] = useState('');
  const [err, setErr] = useState('');

  const run = async (scope) => {
    setBusy(true); setOut(''); setErr('');
    try {
      const fn = httpsCallable(getFunctions(undefined, REGION), 'backfillOrgMembers');
      const payload = scope === 'one' ? { orgId: orgId.trim() || undefined } : {};
      const res = await fn(payload);
      setOut(JSON.stringify(res.data || res, null, 2));
    } catch (e) {
      setErr(e?.message || String(e));
    } finally {
      setBusy(false);
    }
  };

  const isSuper = claims?.superAdmin === true || claims?.superadmin === true;
  if (!isSuper) return <div className="text-rose-300">Super admin only.</div>;

  return (
    <section className="space-y-4">
      <h2 className="text-xl font-semibold">Tools</h2>

      <div className="bg-white/5 border border-white/10 rounded p-4 space-y-3">
        <div className="text-sm opacity-80">
          Backfill the <code>managers</code> collection from Auth custom claims.
        </div>

        <div className="flex gap-2">
          <input
            className="flex-1 bg-black/30 border border-white/10 rounded px-3 py-2"
            placeholder="Org ID (optional)"
            value={orgId}
            onChange={(e) => setOrgId(e.target.value)}
          />
          <button
            disabled={busy || !orgId.trim()}
            onClick={() => run('one')}
            className="px-3 py-2 rounded bg-cyan-600 disabled:opacity-60"
          >
            Backfill one
          </button>
          <button
            disabled={busy}
            onClick={() => run('all')}
            className="px-3 py-2 rounded bg-indigo-600 disabled:opacity-60"
          >
            Backfill all orgs
          </button>
        </div>

        {busy && <div className="text-xs opacity-70">Working…</div>}
        {err && <pre className="text-rose-300 text-xs whitespace-pre-wrap">{err}</pre>}
        {out && <pre className="text-green-300 text-xs whitespace-pre-wrap">{out}</pre>}
      </div>
    </section>
  );
}
